import React from 'react';

const AnnotationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M11.61,14.21H5L4.17,16a4,4,0,0,0-.39,1.5,1.22,1.22,0,0,0,.64,1.15A5.21,5.21,0,0,0,6.26,19v.51H0V19a2.82,2.82,0,0,0,1.67-.82,11.47,11.47,0,0,0,1.61-2.82L10,.48h.27l6.79,15.3a9.32,9.32,0,0,0,1.6,2.74A2.17,2.17,0,0,0,20,19v.51H10.89V19h.37a2.92,2.92,0,0,0,1.55-.3.73.73,0,0,0,.3-.63,1.81,1.81,0,0,0-.08-.51c0-.08-.16-.43-.42-1Zm-.47-1L8.33,6.77,5.44,13.19Z" />
  </svg>
);

export default AnnotationIcon;
